import fetchDataFromSpreadsheet from "./getCompanyDataFromGoogleSheets";

async function fetchSpreadsheetData(client) {
  const rows = await fetchDataFromSpreadsheet(client);

  const companyNamesSet = new Set();
  const companyCountriesSet = new Set();
  const sectorsSet = new Set();

  rows.map((row) => {
    companyNamesSet.add(row['name']?.trim());
    companyCountriesSet.add(row['country']?.trim());
    sectorsSet.add(row['sector']?.trim());
  });

  // Convert sets to arrays
  const companyNames = Array.from(companyNamesSet);
  const companyCountries = Array.from(companyCountriesSet);
  const sectors = Array.from(sectorsSet);

  return { companyNames, companyCountries, sectors };
}
export default fetchSpreadsheetData;
